module.exports = __webpack_public_path__ + "img/mail-blue.e76e3f6.svg";